import React, { useRef, useEffect, useState, memo } from 'react';
import ReactDOM from 'react-dom';
import MapBox from './MapBox';




const QueryController = ({ bounds, filterTerms, setData }) => {
    
    const [timer, setTimer] = useState(null);
    
    const debounce = (method, delayMs) => {
        delayMs = delayMs || 250;
        setTimer(null);
        clearTimeout(timer);
        var t = setTimeout(() => {
            method()
        }, delayMs);
        setTimer(t);
    }

    useEffect(() => {

        if (bounds) {
            debounce(() => {
                console.log("QueryController running");
                var payload = {
                    LatN: bounds._ne.lat,
                    LatS: bounds._sw.lat,
                    LonE: bounds._ne.lng,
                    LonW: bounds._sw.lng,
                    FilterTerms: filterTerms.map(a => ({ "label": a.label, "field": a.field, "type":a.type, "from":a.from, "to":a.to }))
                };
                console.log(payload);
                fetch("https://mihousesearchapi.azurewebsites.net/api/filter/box3", {
                //fetch("http://localhost:8001/api/filter/box3", {
                //
                    method: 'POST',  
                    headers: {
                        "Content-Type": "application/json",
                    },
                    redirect: "follow",
                    body: JSON.stringify(payload),
                }).then((resp) => {
                    if (resp.status == 200 && resp) {
                        return resp.json();
                    }
                    console.log(resp);
                }).then(body => {
                    setData(body);
                });
            });
        }
    }, [bounds, filterTerms, setData ]);

    return null;

}

export default memo(QueryController);